import { CoralogixRum } from "@coralogix/browser";
export const RUM_INSTRUMENTATIONS = { interactions: false };
function stripQuery(url) {
  return typeof url === "string" ? url.split(/[?#]/)[0] : url;
}
export function redactUrls(event) {
  const page = event.page_context;
  if (page) {
    page.page_url = stripQuery(page.page_url);
    page.page_url_blueprint = stripQuery(page.page_url_blueprint);
    page.referrer = stripQuery(page.referrer);
  }
  const network = event.network_request_context;
  if (network) {
    network.url = stripQuery(network.url);
    network.url_blueprint = stripQuery(network.url_blueprint);
  }
  const resource = event.resource_context;
  if (resource) {
    resource.name = stripQuery(resource.name);
  }
  return event;
}
export function initObservability() {
  const publicKey = process.env.VITE_CORALOGIX_RUM_KEY;
  const coralogixDomain = process.env.VITE_CORALOGIX_DOMAIN;
  if (!publicKey || !coralogixDomain) return;
  try {
    CoralogixRum.init({
      public_key: publicKey,
      coralogixDomain,
      application: process.env.VITE_CORALOGIX_APPLICATION || "retail-iframe",
      // Must match the version passed to the sourcemap uploader, or stack
      // traces won't de-minify. CI feeds both from CI_COMMIT_SHORT_SHA.
      version: process.env.VITE_APP_VERSION || "0.0.0",
      environment: process.env.VITE_CORALOGIX_ENVIRONMENT,
      instrumentations: RUM_INSTRUMENTATIONS,
      beforeSend: redactUrls
    });
  } catch (error) {
    console.warn("Coralogix RUM init failed; continuing without RUM", error);
  }
}
